var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96134 0C6.24999 3.73426e-05 7.25945 0.576557 7.98969 1.72956C8.76288 2.83651 9.19243 4.35853 9.27835 6.2956V13.5597H11.0825L14.1108 16.8805H9.27835V26.2893C9.27834 27.0273 9.53607 27.696 10.0515 28.2956C10.567 28.8952 11.4046 29.195 12.5644 29.195C14.0679 29.195 15.6572 28.2956 17.3325 26.4969C19.0507 24.652 19.9527 22.761 20.0387 20.8239L19.2655 20.8931C16.5163 20.8931 15.1417 19.325 15.1418 16.1887C15.1417 15.1279 15.4639 14.1824 16.1082 13.3522C16.7526 12.522 17.8264 12.1069 19.3299 12.1069C20.9192 12.1069 22.2508 12.8449 23.3247 14.3208C24.4416 15.7967 25 17.5954 25 19.717C25 22.8533 23.7543 25.8512 21.2629 28.7107C18.8144 31.5702 15.8935 33 12.5 33C11.2543 33 9.92267 32.4235 8.50515 31.2704C7.13058 30.0713 6.31443 28.9182 6.0567 27.8113V16.8805H2.96392L0 13.5597H6.0567V6.98742C6.0567 5.64993 5.30498 4.86586 3.80155 4.63522C3.11426 4.63526 2.66323 4.75056 2.44845 4.98114C2.06185 4.28934 1.69674 3.45916 1.35309 2.49057V2.14465C1.35309 1.54511 1.78264 1.03778 2.64175 0.622645C3.50086 0.207589 4.27405 3.73426e-05 4.96134 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTklogo);
export default __webpack_public_path__ + "static/media/tk logo.969af97c58930d7682d86f74e7da0fc5.svg";
export { ForwardRef as ReactComponent };